import { useState, useEffect } from 'react'

import {
    SPOT_BASE_URL,
    PRODWS_BASE_URL,
    ACCOUNTWS_BASE_URL,
    ELECTRICIMP_API_BASE_URL,
    DEVICE_HEALTH_STATUS_TEMPLATE_ID,
    OCCUPANCY_TEMPLATE_ID,
    RAW_PEOPLE_COUNT_TEMPLATE_ID,
    LORAWAN_NETWORK_HEALTH_TEMPLATE_ID,
    TIM_FAMILY_PRODUCTS,
} from "../config/config";

import DebugInfoContext from './DebugContext';
import bootstrap from "../config/bootstrap";

const init = bootstrap;

const DebugContextProvider = ({ children }) => {
    const { spaceIOService } = init();

    const [Id, setId] = useState(null);
    const [isDataReady, setIsDataReady] = useState(false);
    const [deviceIsValid, setDeviceIsValid] = useState(false);
    const [headerData, setHeaderData] = useState(null);
    const [impInfoData, setImpInfoData] = useState(null);
    const [AgentData, setAgentData] = useState(null);
    const [assetInfoData, setassetInfoData] = useState(null);
    const [healthInfoFromSPOT, setHealthInfoFromSPOT] = useState(null);
    const [riskInfoFromSPOT, setRiskInfoFromSPOT] = useState(null);
    const [networkInfoFromSPOT, setNetworkInfoFromSPOT] = useState(null);
    const [countAndCoordinatesData, setcountAndCoordinatesData] = useState(null);
    const [occupancyData, setoccupancyData] = useState(null);

    const fetchBaseData = async (arrayOfDeviceIds) => {
        try {
            if (arrayOfDeviceIds === null || arrayOfDeviceIds.length === 0) {
                return [];
            }
            const response = await spaceIOService.request({
                url: `${ACCOUNTWS_BASE_URL}/api/admin/devices`,
                init: {
                    method: "post",
                    body: JSON.stringify(arrayOfDeviceIds),
                    headers: { "Content-Type": "application/json" },
                },
            });
            const responseData = await response.json();

            return responseData;
        } catch (error) {
            console.log(error);
        }
    };

    const serachAPI = async (arrayOfInstallIds) => {
        try {
            if (arrayOfInstallIds === null || arrayOfInstallIds.length === 0) {
                return [];
            }
            const response = await spaceIOService.request({
                url: `${ACCOUNTWS_BASE_URL}/api/admin/devices/search?type=installid`,
                init: {
                    method: "post",
                    body: JSON.stringify(arrayOfInstallIds),
                    headers: { "Content-Type": "application/json" },
                },
            });
            const responseData = await response.json();
            
            return responseData;
        } catch (error) {
            console.log(error);
        }
    };

    const serachProductNameId = async (productId) => {
        try {
            if (productId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${PRODWS_BASE_URL}/api/admin/searchProducts`,
                init: {
                    method: "get",
                    headers: { "Content-Type": "application/json" },
                },
            });
            const responseData = await response.json();

            // Filter objects where id is productId
            const filteredArray = responseData.filter(
                (item) => item.id === productId
            );
            return filteredArray[0];
        } catch (error) {
            console.log(error);
        }
    };

    const getDeviceSummary = async (macId) => {
        try {
            if (macId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${ELECTRICIMP_API_BASE_URL}/summary?deviceId=${macId}`,
                init: {
                    method: "get",
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();

            return responseData.response.data;
        } catch (error) {
            console.log(error);
        }
    };

    const getAccountInfo = async (accountId) => {
        try {
            if (accountId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${ACCOUNTWS_BASE_URL}/api/admin/accounts/${accountId}`,
                init: {
                    method: "get",
                    headers: { "Content-Type": "application/json" },
                },
            });
            const responseData = await response.json();

            return responseData;
        } catch (error) {
            console.log(error);
        }
    };

    const fetchAgentData = async (agentId) => {
        try {
            if (agentId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${ELECTRICIMP_API_BASE_URL}/agent?agentId=${agentId}`,
                init: {
                    method: "get",
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();
            return responseData.response[0];
        } catch (error) {
            console.log(error);
        }
    };

    const fetchHealthDataFromSpot = async (assetId) => {
        try {
            if (assetId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${SPOT_BASE_URL}/assets/data/10/current`,
                init: {
                    method: "post",
                    body: JSON.stringify([assetId]),
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();
            
            return responseData[0];
        } catch (error) {
            console.log(error);
        }
    };

    const fetchNetworkDataFromSpot = async (assetId) => {
        try {
            if (assetId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${SPOT_BASE_URL}/assets/data/${LORAWAN_NETWORK_HEALTH_TEMPLATE_ID}/current`,
                init: {
                    method: "post",
                    body: JSON.stringify([assetId]),
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();
            
            return responseData[0];
        } catch (error) {
            console.log(error);
        }
    };
    const fetchCountAndCoordinatesDataFromSpot = async (assetId) => {
        try {
            if (assetId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${SPOT_BASE_URL}/assets/data/${RAW_PEOPLE_COUNT_TEMPLATE_ID}/current`,
                init: {
                    method: "post",
                    body: JSON.stringify([assetId]),
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();
            
            return responseData[0];
        } catch (error) {
            console.log(error);
        }
    };
    const fetchRiskFromSpot = async (assetId) => {
        try {
            if (assetId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${SPOT_BASE_URL}/assets/data/${DEVICE_HEALTH_STATUS_TEMPLATE_ID}/current`,
                init: {
                    method: "post",
                    body: JSON.stringify([assetId]),
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();
            
            return responseData[0];
        } catch (error) {
            console.log(error);
        }
    };
    const fetchOccupancyDataFromSpot = async (assetId) => {
        try {
            if (assetId === null) {
                return {};
            }
            const response = await spaceIOService.request({
                url: `${SPOT_BASE_URL}/assets/data/${OCCUPANCY_TEMPLATE_ID}/current`,
                init: {
                    method: "post",
                    body: JSON.stringify([assetId]),
                    headers: { "Content-Type": "application/json" },
                },
                bearerToken: true,
            });
            const responseData = await response.json();
            
            return responseData[0];
        } catch (error) {
            console.log(error);
        }
    };


    // Function for fetching Gen4 Mac.
    const checkGen4Mac = (searchAPIData) => {
        // TODO: Add specific logic for Gen4 MAC calculation
        
        const deviceId = searchAPIData[0]?.device?.hardware?.deviceId;
        // Placeholder - return the deviceId for now, modify as needed
        return deviceId?.startsWith('0080') ? true : false;
    }

    const main = async () => {
        const baseDataArray = await fetchBaseData(Id);
        if (baseDataArray && baseDataArray[0] && 'id' in baseDataArray[0]) {
            setDeviceIsValid(true);
        }
        else {
            setDeviceIsValid(false);
            setIsDataReady(false);
            return;
        }

        const arrayOfIds = baseDataArray.map(item => item.id);
        const searchAPIData = await serachAPI(arrayOfIds);
        const isGen4Device = checkGen4Mac(searchAPIData);
        const deviceSummaryData = await getDeviceSummary(searchAPIData[0]?.device?.hardware?.deviceId);
        const accountInfo = await getAccountInfo(searchAPIData[0]?.account?.id);
        const deviceAgentData = await fetchAgentData(deviceSummaryData?.attributes?.agent_id); // , arrayOfIds);
        const productInfoByProductId = await serachProductNameId(searchAPIData[0]?.device?.hardware?.productId)
        const SPOT_HealthData = await fetchHealthDataFromSpot(productInfoByProductId?.name === 'ONE' || productInfoByProductId?.name?.includes('Z4') ||productInfoByProductId?.name === 'ONE-M' || productInfoByProductId?.name === 'ONE-Z' || isGen4Device ? searchAPIData[0]?.device?.assetId : searchAPIData[0]?.spaces[0]?.assetId);
        const SPOT_RiskData = await fetchRiskFromSpot(searchAPIData[0]?.device?.assetId);

        const spaceAssetId = searchAPIData[0]?.spaces[0]?.assetId;
        const deviceAssetId = searchAPIData[0]?.device?.assetId;

        const hasNetworkSignature = isGen4Device && (productInfoByProductId?.name === 'TIM-4' || productInfoByProductId?.name === 'ONE-Z4' || productInfoByProductId?.name === 'ONE-4');

        let SPOT_NetworkData = null;
        let SPOT_CountAndCoordinatesData = null;
        let SPOT_OccupancyData = null;

        const isTimFamily = TIM_FAMILY_PRODUCTS.includes(productInfoByProductId?.name?.toUpperCase());
        const isTim4 = productInfoByProductId?.name?.toUpperCase() === 'TIM-4';

        if (isTimFamily) {
            SPOT_CountAndCoordinatesData = await fetchCountAndCoordinatesDataFromSpot(deviceAssetId);

            SPOT_OccupancyData = await fetchOccupancyDataFromSpot(spaceAssetId);
            if (isTim4 && (!SPOT_OccupancyData || !SPOT_OccupancyData.value)) {
                SPOT_OccupancyData = await fetchOccupancyDataFromSpot(deviceAssetId);
            }
        }

        if (hasNetworkSignature) {
            SPOT_NetworkData = await fetchNetworkDataFromSpot(spaceAssetId);
            if (!SPOT_NetworkData || (!SPOT_NetworkData.fCnt && SPOT_NetworkData.fCnt !== 0)) {
                SPOT_NetworkData = await fetchNetworkDataFromSpot(deviceAssetId);
            }
        }

        // Function for fetching Ethernet Mac.
        const fetchEthernetMac = () => {
            const impId = searchAPIData[0]?.device?.hardware?.deviceId?.substring(0,4);
            const mac = searchAPIData[0]?.device?.hardware?.deviceId.substring(4);
            const ssidArray = JSON.parse(searchAPIData[0]?.device?.network?.ssid);
            return impId + (ssidArray?.[0] == "Ethernet" ? ssidArray?.[1] : (parseInt(mac, 16) + parseInt(1)).toString(16));
        }

        const headerInfo = {
            isGen4Device: isGen4Device,
            productTypeInfo: productInfoByProductId,
            accountInfo: {
                ...searchAPIData[0]?.account,
                logoUrl: accountInfo?.logoUrl
            },
            floorId: searchAPIData[0]?.location?.id,
            floorName: searchAPIData[0]?.location?.name,
            floorLiveStatus: searchAPIData[0].location?.showInMenu ? searchAPIData[0].location?.showInMenu : false,
            blessId: searchAPIData[0]?.device?.blessId,
            installId: searchAPIData[0]?.device?.id,
            // Only include regular macId for non-Z4 devices
            ...( !isGen4Device && { macId: searchAPIData[0]?.device?.hardware?.deviceId }),
            ...( isGen4Device && { GEN4MacId: searchAPIData[0]?.device?.hardware?.deviceId }),
            ...( productInfoByProductId?.name?.includes("POE") && !isGen4Device && { poeMacId: fetchEthernetMac() })
        };

        const SPOT_assetInfo = {
            ownerId: accountInfo?.ownerId,
            spaceId: searchAPIData[0]?.spaces[0]?.id,
            spaceAssetId: searchAPIData[0]?.spaces[0]?.assetId,
            itemId: searchAPIData[0]?.device?.itemId,
            deviceAssetId: searchAPIData[0]?.device?.assetId,
        }

        const electricIMPInfo = {
            devicegroupType: deviceSummaryData?.relationships?.devicegroup?.type,
            device_online: deviceSummaryData?.attributes?.device_online,
            agent_running: deviceSummaryData?.attributes?.agent_running,
            agent_id: deviceSummaryData?.attributes?.agent_id,
            free_memory: deviceSummaryData?.attributes?.free_memory,
            device_id: deviceSummaryData?.id,
            summary: deviceSummaryData
        }

        

        setImpInfoData(electricIMPInfo);
        setHeaderData(headerInfo);
        setAgentData(deviceAgentData)
        setHealthInfoFromSPOT(SPOT_HealthData);
        setRiskInfoFromSPOT(SPOT_RiskData);
        setassetInfoData(SPOT_assetInfo);
        setNetworkInfoFromSPOT(SPOT_NetworkData);
        setcountAndCoordinatesData(SPOT_CountAndCoordinatesData);
        setoccupancyData(SPOT_OccupancyData);

        setIsDataReady(true);
    };

    function formatMacAddress(mac, withImpId = true) {
        if (!mac) return;

        let truncatedMac = mac;
        if(withImpId) {
            truncatedMac = mac.substring(4);
        }
        const macPairs = truncatedMac.match(/.{1,2}/g);
        const formattedMac = macPairs.join(':');
        return formattedMac;
    }

    useEffect(() => {
        if (Id) {
            setDeviceIsValid(false);
            setIsDataReady(false);
            main();
        } else {
            // No device ID provided
        }
    }, [Id]);


    return (
        <DebugInfoContext.Provider value={{
            Id, setId,
            isDataReady,
            deviceIsValid,
            headerData,
            impInfoData,
            AgentData,
            assetInfoData,
            healthInfoFromSPOT,
            riskInfoFromSPOT,
            networkInfoFromSPOT,
            countAndCoordinatesData,
            occupancyData,
            formatMacAddress
        }}>
            {children}
        </DebugInfoContext.Provider>
    )
}


// Skip prop validation by setting propTypes to null
DebugContextProvider.propTypes = null;

export default DebugContextProvider